import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userSlice';
import productReducer from './productSlice';
import calendarReducer from './calendarSlice';
import salesReducer from './salesSlice';
import adminReducer from './adminSlice';
import bonusPrizeReducer from './bonusPrizeSlice';

const migrations = {
  0: (state) => state,
  1: (state) => ({ ...state }),
  2: (state) => ({ ...state }),
  3: (state) => ({ ...state }),
  4: (state) => {
    const { product, bundle, ...rest } = state;
    return rest;
  },
  5: (state) => {
    const { bundle, calendar, ...rest } = state;
    return rest;
  },
  6: (state) => {
    const { sales, ...rest } = state;
    return rest;
  },
  7: (state) => {
    const { product, ...rest } = state;
    return rest;
  },
  8: (state) => {
    const { product, ...rest } = state;
    return rest;
  },
  9: (state) => {
    const { calendar, ...rest } = state;
    return rest;
  },
  10: (state) => {
    const { calendar, ...rest } = state;
    return rest;
  },
  11: (state) => {
    const { product, ...rest } = state;
    return rest;
  },
  12: (state) => {
    const { product, ...rest } = state;
    return rest;
  },
  13: (state) => {
    const { product, ...rest } = state;
    return rest;
  },
  14: (state) => {
    const { product, calendar, sales, admin, ...rest } = state;
    return rest;
  },
  15: (state) => {
    const { bonusPrize, ...rest } = state;
    return rest;
  },
};

const rootReducer = combineReducers({
  user: userReducer,
  product: productReducer,
  calendar: calendarReducer,
  sales: salesReducer,
  admin: adminReducer,
  bonusPrize: bonusPrizeReducer,
});

const persistConfig = {
  key: 'lottery-manager',
  storage,
  version: 15,
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
